<template>
  <div class="el-stripe">
    <!-- PIX -->
    <pixConfig
      :pix="pix"
      :pixAffiliations="pixAffiliations"
      :account="account"
      :merchantId="merchantId"
      :accountLoading="accountLoading"
      :modalPix="modalPix"
      @defaultPixRecipientEmit="defaultPixRecipientEmit"
      @onToggleModalPix="onToggleModalPix"
    />
    <!-- Cartão de crédito -->
    <creditcard-config
      :title="$t('account.settings.credit-card.title')"
      :callback="saveCreditConfig"
      :loading="accountLoading"
      @cancelEdit="resetObject(creditCard, paymentMethods.creditCard)"
      :hideEditButton="
        !permissionIsEnabled('settings.payments.credit_card:edit')
      "
      v-if="permissionIsEnabled('settings.payments.credit_card:view')"
    >
      <template slot="content">
        <div class="emd-panel">
          <div class="emd-panel__section">
            <div class="emd-panel__block">
              <div class="el-chunk">
                <h2 class="emd-text _color_default _type_caption">
                  {{ $t('account.settings.credit-card.config') }}
                </h2>
              </div>
            </div>
            <div class="emd-panel__block">
              <!-- Status cartão de crédito -->
              <div class="el-chunk">
                <div class="emd-form-group">
                  <label
                    class="emd-label"
                    for="status"
                    >{{ $t('account.settings.credit-card.status') }}</label
                  >
                  <label
                    class="emd-switcher__label"
                    for="enabledCreditCard"
                  >
                    <input
                      class="emd-switcher _color_success"
                      checked="checked"
                      type="checkbox"
                      id="enabledCreditCard"
                      v-model="creditCard.enabled"
                    />
                    <div class="emd-switcher__area"></div>
                    <span class="emd-switcher__text">{{
                      $t('account.settings.credit-card.active')
                    }}</span>
                  </label>
                </div>
              </div>
              <!-- Gateway cartão de crédito -->
              <div class="el-chunk">
                <div class="emd-form-group">
                  <label
                    class="emd-label _required"
                    for="gatewayCreditCard"
                    >{{ $t('account.settings.credit-card.gateway') }}</label
                  >
                  <div
                    class="emd-select"
                    id="gatewayCreditCard"
                  >
                    <select v-model="creditCard.gateway">
                      <option
                        v-for="(gateway, index) in gateways"
                        :value="gateway.key"
                        :key="index"
                      >
                        {{ gateway.value }}
                      </option>
                    </select>
                    <div class="emd-select__arrow"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </creditcard-config>

    <debitcard-config
      :title="$t('account.settings.debit-card.title')"
      :callback="saveDebitConfig"
      :loading="accountLoading"
      @cancelEdit="resetObject(debitCard, paymentMethods.debitCard)"
      :hideEditButton="
        !permissionIsEnabled('settings.payments.debit_card:edit')
      "
      v-if="permissionIsEnabled('settings.payments.debit_card:view')"
    >
      <template slot="content">
        <div class="emd-panel">
          <div class="emd-panel__section">
            <div class="emd-panel__block">
              <div class="el-chunk">
                <h2 class="emd-text _color_default _type_caption">
                  {{ $t('account.settings.debit-card.config') }}
                </h2>
              </div>
            </div>
            <div class="emd-panel__block">
              <!-- Status cartão de débito -->
              <div class="el-chunk">
                <div class="emd-form-group">
                  <label
                    class="emd-label"
                    for="status"
                    >{{ $t('account.settings.debit-card.status') }}</label
                  >
                  <label
                    class="emd-switcher__label"
                    for="enabledCreditDebit"
                  >
                    <input
                      class="emd-switcher _color_success"
                      checked="checked"
                      type="checkbox"
                      id="enabledCreditDebit"
                      v-model="debitCard.enabled"
                    />
                    <div class="emd-switcher__area"></div>
                    <span class="emd-switcher__text">{{
                      $t('account.settings.debit-card.active')
                    }}</span>
                  </label>
                </div>
              </div>
              <!-- Gateway cartão de débito -->
              <div class="el-chunk">
                <div class="emd-form-group">
                  <label
                    class="emd-label _required"
                    for="gatewayCreditDebit"
                    >{{ $t('account.settings.debit-card.gateway') }}</label
                  >
                  <div
                    class="emd-select"
                    id="gatewayCreditDebit"
                  >
                    <select v-model="debitCard.gateway">
                      <option
                        v-for="(gateway, index) in gateways"
                        :value="gateway.key"
                        :key="index"
                      >
                        {{ gateway.value }}
                      </option>
                    </select>
                    <div class="emd-select__arrow"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </debitcard-config>

    <boleto-config
      :title="$t('account.settings.boleto.title')"
      :callback="saveBoletoConfig"
      :loading="accountLoading"
      @cancelEdit="resetBoleto(boleto, paymentMethods.boleto)"
      :formIsInvalid="!instructionsIsValid"
      :hideEditButton="!permissionIsEnabled('settings.payments.boleto:edit')"
      v-if="permissionIsEnabled('settings.payments.boleto:view')"
    >
      <template slot="content">
        <div class="emd-panel">
          <div class="emd-panel__section">
            <div class="emd-panel__block">
              <div class="el-chunk">
                <h2 class="emd-text _color_default _type_caption">
                  {{ $t('account.settings.boleto.config') }}
                </h2>
              </div>
            </div>
            <div class="emd-panel__block">
              <!-- Status boleto -->
              <div class="el-chunk">
                <div class="emd-form-group">
                  <label
                    class="emd-label"
                    for="status"
                    >{{ $t('account.settings.boleto.status') }}</label
                  >
                  <label
                    class="emd-switcher__label"
                    for="enabledBoleto"
                  >
                    <input
                      class="emd-switcher _color_success"
                      checked="checked"
                      type="checkbox"
                      id="enabledBoleto"
                      v-model="boleto.enabled"
                    />
                    <div class="emd-switcher__area"></div>
                    <span class="emd-switcher__text">{{
                      $t('account.settings.boleto.active')
                    }}</span>
                  </label>
                </div>
              </div>
              <!-- Boleto Stone -->
              <div
                class="el-chunk"
                v-if="isBoletoStoneVisible"
              >
                <emd-alert
                  v-if="statusBoletoStone.alert"
                  :variant="statusBoletoStone.alert.type"
                  :title="statusBoletoStone.alert.title"
                  @cancel="onCleanAlertBoletoStone"
                >
                  <template slot="content">
                    <p>{{ statusBoletoStone.alert.description }}</p>
                  </template>
                </emd-alert>
                <div class="emd-form-group">
                  <emd-frame
                    :badges="statusBoletoStone.badges"
                    :title="$t('account.settings.boleto.stone.title')"
                    :active="true"
                    :button-position="
                      statusBoletoStone.type === 'Enabled' ? 'bottom' : 'middle'
                    "
                    :text="statusBoletoStone.text"
                    :button-label="statusBoletoStone.button"
                    :button-hide="!statusBoletoStone.method"
                    @click="statusBoletoStone.method"
                  />
                </div>
                <div class="emd-form-group">
                  <emd-frame
                    :badges="[]"
                    :title="$t('account.settings.boleto.other-bank.title')"
                    :text="$t('account.settings.boleto.other-bank.description')"
                    :button-hide="true"
                    @click="null"
                  />
                </div>
              </div>
              <!-- Banco boleto -->
              <div
                class="el-chunk"
                v-if="!isProductionAccount"
              >
                <div class="emd-form-group">
                  <label
                    class="emd-label _required"
                    for="boletoBank"
                    >{{ $t('account.settings.boleto.bank') }}</label
                  >
                  <div
                    class="emd-select"
                    id="boletoBank"
                  >
                    <select v-model="boleto.bank">
                      <option
                        v-for="(bank, index) of bankOptionsBoleto"
                        :value="index"
                        :key="index"
                      >
                        {{ bank }}
                      </option>
                    </select>
                    <div class="emd-select__arrow"></div>
                  </div>
                </div>
              </div>
              <!-- Gateway boleto -->
              <div class="el-chunk">
                <div class="emd-form-group">
                  <label
                    class="emd-label _required"
                    for="gatewayBoleto"
                    >{{ $t('account.settings.boleto.gateway') }}</label
                  >
                  <div
                    class="emd-select"
                    id="gatewayBoleto"
                  >
                    <select v-model="boleto.gateway">
                      <option
                        v-for="(gateway, index) in gateways"
                        :value="gateway.key"
                        :key="index"
                      >
                        {{ gateway.value }}
                      </option>
                    </select>
                    <div class="emd-select__arrow"></div>
                  </div>
                </div>
              </div>
              <!-- Dias para vencimento do boleto -->
              <div class="el-chunk">
                <div class="emd-form-group">
                  <label
                    class="emd-label"
                    for="minDueDays"
                    >{{ $t('account.settings.boleto.due-days') }}</label
                  >
                  <input
                    class="emd-input"
                    id="minDueDays"
                    type="text"
                    v-model="boleto.due_days"
                    placeholder="Mínimo de 1 dia"
                  />
                </div>
              </div>
              <!-- Instruções boleto -->
              <div class="el-chunk">
                <div
                  class="emd-form-group"
                  v-bind:class="{ _state_error: !instructionsIsValid }"
                >
                  <label
                    class="emd-label _required"
                    for="instructionsBoleto"
                    >{{ $t('account.settings.boleto.instructions') }}</label
                  >
                  <textarea
                    id="instructionsBoleto"
                    class="emd-input"
                    type="text"
                    cols="30"
                    rows="10"
                    v-model="boleto.instructions"
                    @input="validateInstructions"
                  >
                  </textarea>
                  <span
                    v-if="!instructionsIsValid"
                    class="emd-input-feedback"
                    >{{
                      $t('account.settings.boleto.instructions-feedback')
                    }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </boleto-config>

    <voucher-config
      :title="$t('account.settings.voucher.title')"
      :callback="saveVoucherConfig"
      :loading="accountLoading"
      @cancelEdit="resetObject(voucher, paymentMethods.voucher)"
      :hideEditButton="!permissionIsEnabled('settings.payments.voucher:edit')"
      v-if="permissionIsEnabled('settings.payments.voucher:view')"
    >
      <template slot="content">
        <div class="emd-panel">
          <div class="emd-panel__section">
            <div class="emd-panel__block">
              <div class="el-chunk">
                <h2 class="emd-text _color_default _type_caption">
                  {{ $t('account.settings.voucher.config') }}
                </h2>
              </div>
            </div>
            <div class="emd-panel__block">
              <!-- Status voucher -->
              <div class="el-chunk">
                <div class="emd-form-group">
                  <label
                    class="emd-label"
                    for="status"
                    >{{ $t('account.settings.voucher.status') }}</label
                  >
                  <label
                    class="emd-switcher__label"
                    for="enabledVoucher"
                  >
                    <input
                      class="emd-switcher _color_success"
                      checked="checked"
                      type="checkbox"
                      id="enabledVoucher"
                      v-model="voucher.enabled"
                    />
                    <div class="emd-switcher__area"></div>
                    <span class="emd-switcher__text">{{
                      $t('account.settings.voucher.active')
                    }}</span>
                  </label>
                </div>
              </div>

              <!-- Gateway voucher -->
              <div class="el-chunk">
                <div class="emd-form-group">
                  <label
                    class="emd-label _required"
                    for="gatewayVoucher"
                    >{{ $t('account.settings.voucher.gateway') }}</label
                  >
                  <div
                    class="emd-select"
                    id="gatewayVoucher"
                  >
                    <select v-model="voucher.gateway">
                      <option
                        v-for="(gateway, index) in gateways"
                        :value="gateway.key"
                        :key="index"
                      >
                        {{ gateway.value }}
                      </option>
                    </select>
                    <div class="emd-select__arrow"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </voucher-config>

    <!-- Cash -->
    <cash-config
      :title="$t('account.settings.cash.title')"
      :callback="saveCashConfig"
      :loading="accountLoading"
      @cancelEdit="resetObject(cash, paymentMethods.cash)"
      :hideEditButton="!permissionIsEnabled('settings.payments.cash:edit')"
      v-if="permissionIsEnabled('settings.payments.cash:view')"
    >
      <template slot="content">
        <div class="emd-panel">
          <div class="emd-panel__section">
            <div class="emd-panel__block">
              <div class="el-chunk">
                <h2 class="emd-text _color_default _type_caption">
                  {{ $t('account.settings.cash.config') }}
                </h2>
              </div>
            </div>
            <div class="emd-panel__block">
              <!-- Status wallet global -->
              <div class="el-chunk">
                <div class="emd-form-group">
                  <label
                    class="emd-label"
                    for="status"
                    >{{ $t('account.settings.cash.status') }}</label
                  >
                  <label
                    class="emd-switcher__label"
                    for="enabledWalletGlobal"
                  >
                    <input
                      class="emd-switcher _color_success"
                      checked="checked"
                      type="checkbox"
                      id="enabledWalletGlobal"
                      v-model="cash.enabled"
                    />
                    <div class="emd-switcher__area"></div>
                    <span class="emd-switcher__text">{{
                      $t('account.settings.cash.active')
                    }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </cash-config>

    <modal-create-account
      :isOpen="modalBoletoStone.createAccountIsOpen"
      @onCreateAccount="onRegisterBoletoStone"
      @onClose="onToggleModalBoletoStone('createAccountIsOpen')()"
    />
    <modal-fail-habilitation
      :isOpen="modalBoletoStone.failHabilitationIsOpen"
      @onClose="onToggleModalBoletoStone('failHabilitationIsOpen')()"
    />
    <modal-password
      v-if="modalBoletoStone.enabledIsOpen"
      size="big"
      :text="$t('account.settings.boleto.stone.enable-with-password')"
      :callback="password => onEnableOrDisableBoletoStone(password, true)"
      @cancel="onToggleModalBoletoStone('enabledIsOpen')()"
    />
    <modal-disable
      :isOpen="modalBoletoStone.disabledIsOpen"
      :isLoad="modalBoletoStone.isLoad"
      :error="modalBoletoStone.hasError"
      @onDisable="password => onEnableOrDisableBoletoStone(password, false)"
      @onClose="onToggleModalBoletoStone('disabledIsOpen')()"
    />
    <modal-create-key
      :isOpen="modalPix.createKeyIsOpen"
      :isLoad="modalPix.createIsLoad"
      :error="modalPix.createHasError"
      @onSubmit="password => onCreatePixKey(password)"
      @onClose="onToggleModalPix('createKeyIsOpen')"
      @onCancel="onToggleModalPix('createKeyIsOpen')"
    />
    <modal-delete-key
      :isOpen="modalPix.deleteKeyIsOpen"
      :isLoad="modalPix.deleteIsLoad"
      :error="modalPix.deleteHasError"
      :accountName="defaultPixRecipient.name"
      @onDelete="password => onDeletePixKey(password)"
      @onClose="onToggleModalPix('deleteKeyIsOpen')"
      @onCancel="onToggleModalPix('deleteKeyIsOpen')"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { EmdFrame, EmdAlert } from 'emerald-vue/src/components'
import ConfigBox from '@/components/project/molecules/ConfigBox.vue'

import ModalPassword from '@/components/project/globals/ModalPassword'
import ModalCreateAccount from '@/components/project/globals/BoletoStone/ModalCreateAccount'
import ModalFailHabilitation from '@/components/project/globals/BoletoStone/ModalFailHabilitation'
import ModalDisable from '@/components/project/globals/BoletoStone/ModalDisable'
import ModalCreateKey from '@/components/project/globals/Pix/ModalCreateKey'
import ModalDeleteKey from '@/components/project/globals/Pix/ModalDeleteKey'

import { formatErrorMessage } from '@/support/formatErrorMessage'
import { isTestAccount, isProductionAccount } from '@/enums/environment.enum'
import { isGatewayOrHybrid } from '@/enums/business-model.enum'
import PixConfig from './PixConfig/index'

export default {
  name: 'PaymentMethods',
  components: {
    CreditcardConfig: ConfigBox,
    DebitcardConfig: ConfigBox,
    BoletoConfig: ConfigBox,
    VoucherConfig: ConfigBox,
    CashConfig: ConfigBox,
    EmdAlert,
    EmdFrame,
    ModalPassword,
    ModalCreateAccount,
    ModalFailHabilitation,
    ModalDisable,
    ModalCreateKey,
    ModalDeleteKey,
    PixConfig
  },
  data () {
    return {
      accountLoading: true,
      isTestAccount: null,
      pix: {
        enabled: null,
        gateway: 'pagarme',
        key: null
      },
      defaultPixRecipient: {},
      creditCard: {
        enabled: null,
        gateway: 'mundipagg'
      },
      debitCard: {
        enabled: null,
        gateway: 'mundipagg'
      },
      boleto: {
        enabled: null,
        gateway: 'mundipagg',
        bank: '001',
        instructions: '',
        due_days: null
      },
      voucher: {
        enabled: null,
        gateway: 'mundipagg'
      },
      cash: {
        enabled: null
      },
      gateways: [],
      bankOptionsBoleto: {
        '001': 'Banco do Brasil',
        '033': 'Santander',
        104: 'Caixa Econômica',
        237: 'Bradesco',
        341: 'Itaú',
        745: 'Citibank',
        174: 'Pefisa',
        376: 'JP Morgan',
        198: 'Pagar.me'
      },
      instructionsIsValid: true,
      statusBoletoStone: null,
      modalBoletoStone: {
        createAccountIsOpen: false,
        enabledIsOpen: false,
        disabledIsOpen: false,
        failHabilitationIsOpen: false,
        isLoad: false,
        hasError: null
      },
      modalPix: {
        createKeyIsOpen: false,
        deleteKeyIsOpen: false,
        createOrDeleteIsSuccess: false,
        createOrDeleteAlertMessage: '',
        createIsLoad: false,
        deleteIsLoad: false,
        createHasError: null,
        deleteHasError: null
      },
      pixAffiliations: null
    }
  },
  computed: {
    ...mapGetters({
      account: 'account',
      merchantId: 'merchantId',
      paymentMethods: 'paymentMethods',
      gatewaySettings: 'gatewaySettings',
      affiliations: 'affiliations',
      businessModel: 'businessModel'
    }),
    params () {
      return {
        merchantId: this.merchantId,
        accountId: this.account.id
      }
    },
    isProductionAccount () {
      return isProductionAccount(this.account.account_type.value)
    },
    hasBoletoStone () {
      // Realizado rollback no dia 13/04/2022 devido ao melhor alinhamento a entrega entre as tribos
      return this.statusBoletoStone && this.isProductionAccount
      // return true
    },
    pagarmeSettings () {
      return this.gatewaySettings.pagarme
    },
    mundipaggSettings () {
      return this.gatewaySettings.mundipagg
    },
    isBoletoStoneVisible () {
      return this.hasBoletoStone && isGatewayOrHybrid(this.businessModel)
    }
  },
  created () {
    Promise.all([
      this.getAccount(this.params),
      this.getAffiliations({
        ...this.params,
        isStone: false
      })
    ])
      .then(([_, affiliations]) => {
        this.pixAffiliations = affiliations?.pix_affiliations
        this.requestGateways()
        this.requestBoletoStoneStatus()
        this.isTestAccount = isTestAccount(this.account.account_type.value)
      })
      .catch(e => {
        // eslint-disable-next-line no-console
        console.error('[PaymentMethods] > getAccount', e)
        this.accountLoading = false
      })
      .finally(() => {
        this.pix = Object.assign(this.pix, this.paymentMethods.pix)
        this.creditCard = Object.assign(
          this.creditCard,
          this.paymentMethods.creditCard
        )
        this.debitCard = Object.assign(
          this.debitCard,
          this.paymentMethods.debitCard
        )
        this.boleto = Object.assign(this.boleto, this.paymentMethods.boleto)
        this.voucher = Object.assign(this.voucher, this.paymentMethods.voucher)
        this.cash = Object.assign(this.cash, this.paymentMethods.cash)
        const affiliations = Object.assign(
          this.affiliations,
          this.paymentMethods.affiliations
        )

        this.SET_AFFILIATIONS(affiliations)
      })
  },
  methods: {
    ...mapActions({
      getAccount: 'GET_ACCOUNT',
      getAffiliations: 'GET_AFFILIATIONS',
      SET_AFFILIATIONS: 'SET_AFFILIATIONS'
    }),
    saveCreditConfig (password) {
      this.creditCard.password = password
      return this.$store.dispatch(
        'UPDATE_CREDIT_CARD_SETTINGS',
        this.creditCard
      )
    },
    saveDebitConfig (password) {
      this.debitCard.password = password
      return this.$store.dispatch('UPDATE_DEBIT_CARD_SETTINGS', this.debitCard)
    },
    saveBoletoConfig (password) {
      this.boleto.password = password
      return this.$store.dispatch('UPDATE_BOLETO_SETTINGS', this.boleto)
    },
    saveVoucherConfig (password) {
      this.voucher.password = password
      return this.$store.dispatch('UPDATE_VOUCHER_SETTINGS', this.voucher)
    },
    saveCashConfig (password) {
      this.cash.password = password
      return this.$store.dispatch('UPDATE_CASH_SETTINGS', this.cash)
    },
    onlySimulator (origin) {
      return origin.filter(gateway => gateway.key === 'simulator')
    },
    removeSimulator (origin) {
      return origin.filter(gateway => gateway.key !== 'simulator')
    },
    removePagarme (origin) {
      return origin.filter(gateway => gateway.key !== 'pagarme')
    },
    removeMundipagg (origin) {
      return origin.filter(gateway => gateway.key !== 'mundipagg')
    },
    requestGateways () {
      this.$store
        .dispatch('GET_GATEWAYS')
        .then(response => {
          const hasPagarme =
            this.pagarmeSettings &&
            Object.entries(this.pagarmeSettings).length > 0 &&
            this.pagarmeSettings.constructor === Object
          const hasMundipagg =
            this.mundipaggSettings &&
            Object.entries(this.mundipaggSettings).length > 0 &&
            this.mundipaggSettings.constructor === Object

          this.gateways = response
          this.gatewayPix = this.removeMundipagg(this.gateways)

          if (this.isProductionAccount) {
            this.gateways = this.removeSimulator(this.gateways)
          }
          if (!hasPagarme) {
            this.gateways = this.removePagarme(this.gateways)
          }
          if (!hasMundipagg) this.gateways = this.removeMundipagg(this.gateways)
          this.accountLoading = false
        })
        .catch(() => {
          this.accountLoading = false
        })
    },
    requestBoletoStoneStatus () {
      if (!isGatewayOrHybrid(this.businessModel)) {
        this.statusBoletoStone = null
        return null
      }

      const status = {
        None: {
          type: 'None',
          badges: [
            {
              label: this.$t('account.settings.boleto.stone.new'),
              theme: 'secondary'
            }
          ],
          alert: null,
          method: this.onToggleModalBoletoStone('createAccountIsOpen'),
          text: this.$t('account.settings.boleto.stone.description'),
          button: this.$t('account.settings.boleto.stone.register')
        },
        Processing: {
          type: 'Processing',
          badges: [
            {
              label: this.$t('account.settings.boleto.stone.processing'),
              theme: 'warning'
            }
          ],
          alert: {
            title: this.$t('account.settings.boleto.stone.processing-title'),
            type: 'warning',
            description: this.$t(
              'account.settings.boleto.stone.processing-description'
            )
          },
          method: null,
          text: this.$t('account.settings.boleto.stone.description'),
          button: this.$t('account.settings.boleto.stone.register')
        },
        Disabled: {
          type: 'Disabled',
          badges: [
            {
              label: this.$t('account.settings.boleto.stone.done'),
              theme: 'success'
            },
            {
              label: this.$t('account.settings.boleto.stone.disabled'),
              theme: 'disabled'
            }
          ],
          alert: {
            title: this.$t('account.settings.boleto.stone.done-title'),
            type: 'success',
            description: this.$t(
              'account.settings.boleto.stone.done-description'
            )
          },
          text: this.$t('account.settings.boleto.stone.available'),
          button: this.$t('account.settings.boleto.stone.set-default'),
          method: this.onToggleModalBoletoStone('enabledIsOpen')
        },
        Enabled: {
          type: 'Enabled',
          badges: [
            {
              label: this.$t('account.settings.boleto.stone.done'),
              theme: 'success'
            },
            {
              label: this.$t('account.settings.boleto.stone.default'),
              theme: 'success'
            }
          ],
          alert: {
            title: this.$t('account.settings.boleto.stone.done-title'),
            type: 'success',
            description: this.$t('account.settings.boleto.stone.default-text-2')
          },
          text: this.$t('account.settings.boleto.stone.default-text'),
          button: this.$t('account.settings.boleto.stone.disabled-default'),
          method: this.onToggleModalBoletoStone('disabledIsOpen')
        }
      }

      return Promise.all([
        this.$store.dispatch('GET_BOLETO_STONE_CONSENTS_STATUS', this.params),
        this.$store.dispatch('GET_AFFILIATIONS', {
          ...this.params,
          isStone: true
        })
      ]).then(
        ([
          { status_boleto_stone: statusBoletoStone },
          { boleto_affiliations: boletoAffliations }
        ]) => {
          if (statusBoletoStone === 'Done') {
            statusBoletoStone = boletoAffliations[0].is_enabled
              ? 'Enabled'
              : 'Disabled'
          }
          this.statusBoletoStone = {
            ...this.statusBoletoStone,
            ...status[statusBoletoStone]
          }
        }
      )
    },
    resetBoleto (obj, objFromApi) {
      this.instructionsIsValid = true
      Object.assign(obj, objFromApi)
    },
    resetObject (obj, objFromApi) {
      Object.assign(obj, objFromApi)
    },
    validateInstructions () {
      this.instructionsIsValid = this.boleto.instructions.length <= 256
    },
    permissionIsEnabled (action) {
      return this.$store.getters.permissionIsEnabled(action)
    },
    onRegisterBoletoStone () {
      this.$store
        .dispatch('GET_BOLETO_STONE_CONSENTS', this.params)
        .then(({ consent_url }) => {
          window.open(consent_url)
        })
        .catch(() => {
          this.modalBoletoStone.failHabilitationIsOpen = true
        })
    },
    onEnableOrDisableBoletoStone (password, enabled) {
      this.modalBoletoStone.isLoad = true
      this.modalBoletoStone.hasError = null

      const body = { enabled, password }
      return this.$store
        .dispatch('UPDATE_AFFILIATIONS', { ...this.params, body })
        .then(this.requestBoletoStoneStatus)
        .then(() => {
          const isOpen = enabled ? 'enabledIsOpen' : 'disabledIsOpen'
          this.onToggleModalBoletoStone(isOpen)()
        })
        .catch(error => {
          this.modalBoletoStone.hasError = formatErrorMessage(
            error,
            this.$t('account.settings.pix.error-internal')
          )?.join([' '])
          return error
        })
        .finally(() => {
          this.modalBoletoStone.isLoad = false
        })
    },
    onToggleModalBoletoStone (prop) {
      return () =>
        (this.modalBoletoStone = {
          ...this.modalBoletoStone,
          [prop]: !this.modalBoletoStone[prop]
        })
    },
    onToggleModalPix (prop) {
      this.modalPix = {
        ...this.modalPix,
        [prop]: !this.modalPix[prop]
      }
    },
    defaultPixRecipientEmit (data) {
      this.defaultPixRecipient = data
    },
    onCreatePixKey (password) {
      this.modalPix.createIsLoad = true
      this.modalPix.createHasError = null
      this.modalPix.createOrDeleteIsSuccess = false

      const { recipientId } = this.defaultPixRecipient

      const body = {
        payment_method: 'Pix',
        password,
        recipient_id: recipientId
      }
      return this.$store
        .dispatch('CREATE_PIX_KEY', { ...this.params, body })
        .then(res => {
          this.modalPix.createOrDeleteAlertMessage = this.$t(
            'account.settings.pix.success-on-create-key'
          )
          this.modalPix.createKeyIsOpen = false
          this.pix.key = res.pix.pix_key.id
          this.modalPix.createOrDeleteIsSuccess = true
        })
        .catch(error => {
          this.modalPix.createHasError = formatErrorMessage(
            error,
            this.$t('account.settings.pix.error-internal')
          )?.join([' '])
          return error
        })
        .finally(() => {
          this.modalPix.createIsLoad = false
        })
    },
    onDeletePixKey (password) {
      this.modalPix.deleteIsLoad = true
      this.modalPix.deleteHasError = null
      this.modalPix.createOrDeleteIsSuccess = false

      const body = {
        pix_key: this.pix.key,
        password
      }

      return this.$store
        .dispatch('DELETE_PIX_KEY', { ...this.params, body })
        .then(() => {
          this.modalPix.createOrDeleteAlertMessage = this.$t(
            'account.settings.pix.success-on-delete-key'
          )
          this.modalPix.deleteKeyIsOpen = false
          this.pix.key = null
          this.modalPix.createOrDeleteIsSuccess = true
        })
        .catch(error => {
          this.modalPix.deleteHasError = formatErrorMessage(
            error,
            this.$t('account.settings.pix.error-internal')
          )?.join([' '])
          return error
        })
        .finally(() => {
          this.modalPix.deleteIsLoad = false
        })
    },
    onCleanAlertBoletoStone () {
      this.statusBoletoStone = {
        ...this.statusBoletoStone,
        alert: null
      }
    }
  }
}
</script>
